<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <div
        style="width: 200px"
        class="d-flex align-items-center justify-content-center mb-1 m-auto"
      >
        <img
          style="width: 100%"
          src="https://smartsalesagent.blob.core.windows.net/files/12ef3d82-b66f-47f8-9056-9274cefb198a.png?sv=2021-12-02&st=2025-05-01T10%3A24%3A29Z&se=2125-05-01T10%3A29%3A29Z&sr=b&sp=r&sig=nvAoUGIzdtNC8A9e1DGpA3USSELJWtUes3vg7kuSDZk%3D"
        />
      </div>
      <!-- <h2 class="brand-text text-primary ml-1">SOFIA</h2> -->
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">No estas autorizado! 🔐</h2>
        <p class="mb-2">
          No tienes permiso para acceder a esta página. Ir a Inicio!!
        </p>
        <b-button variant="primary" class="mb-1 btn-sm-block" @click="goHome"
          >Volver al Inicio</b-button
        >
        <b-img fluid :src="imgUrl" alt="Not authorized page" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import { deleteCookie, getCookie, setCookie } from "@/auth/CookiesManager";
import { initialAbility } from "@/libs/acl/config";

export default {
  components: {
    BLink,
    BImg,
    BButton,
    VuexyLogo,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/not-authorized.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/not-authorized-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
  },
  methods: {
    // loginRoute() {
    //   const userRole = getCookie("role") || null;

    //   // Clear Cookies
    //   setCookie("logout", true);
    //   deleteCookie("token");
    //   deleteCookie("role");
    //   deleteCookie("user");
    //   deleteCookie("guidProfile");
    //   deleteCookie("famcos");
    //   const guidCompany = getCookie("guidCompany");
    //   if (guidCompany) {
    //     deleteCookie("guidCompany");
    //     deleteCookie("companyType");
    //     deleteCookie("divisa");
    //   }
    //   // Reset ability
    //   this.$store.commit("appConfig/SET_RESET_TOKEN");
    //   this.$store.commit("appConfig/SET_RESET_STATE");
    //   this.$store.commit("appConfig/SET_RESET_ROLE");
    //   // this.$store.commit("appConfig/SET_RESET_GUID_COMPANY");
    //   this.$store.commit("appConfig/RESET_ACTIVE_COMPANY");
    //   this.$store.commit("appConfig/SET_RESET_DIVISA");
    //   this.$ability.update(initialAbility);

    //   // Redirect to login page
    //   // this.$router.push({ name: "landing" });
    //   // const user = this.parseJwt(storege)
    //   // let parsedState = user ?? null;
    //   return getHomeRouteForLoggedInUser(userRole);
    //   // Remove userData from cookie
    //   // ? You just removed token from cookie. If you like, you can also make API call to backend to blacklist used token
    // },

    goHome() {
      const userRole = getCookie("role") || null;

      setCookie("logout", true);

      deleteCookie("token");
      deleteCookie("role");
      deleteCookie("user");
      deleteCookie("guidProfile");
      deleteCookie("famcos");

      const guidCompany = getCookie("guidCompany");

      if (guidCompany) {
        deleteCookie("guidCompany");
        deleteCookie("companyType");
        deleteCookie("divisa");
      }

      this.$store.commit("appConfig/SET_RESET_TOKEN");
      this.$store.commit("appConfig/SET_RESET_STATE");
      this.$store.commit("appConfig/SET_RESET_ROLE");
      this.$store.commit("appConfig/RESET_ACTIVE_COMPANY");
      this.$store.commit("appConfig/SET_RESET_DIVISA");
      this.$store.commit("appConfig/SET_RESET_SESSION_CONTEXT");

      this.$ability.update(initialAbility);

      const route = getHomeRouteForLoggedInUser(userRole);

      this.$router.push(route);
    },

    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );
      return JSON.parse(jsonPayload);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
